export default __webpack_public_path__ + "static/media/iconBank.c5994943.svg";